// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file support_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file support_service.proto.
 */
export const file_support_service: GenFile = /*@__PURE__*/
  fileDesc("ChVzdXBwb3J0X3NlcnZpY2UucHJvdG8SBmRvbWFpbiL3AQoSU2VuZE1lc3NhZ2VSZXF1ZXN0Eg8KB3N1YmplY3QYASABKAkSDwoHbWVzc2FnZRgCIAEoCRISCgpwcm9maWxlX2lkGAQgASgJEigKBHR5cGUYBSABKA4yGi5kb21haW4uU3VwcG9ydE1lc3NhZ2VUeXBlEjoKC2F0dGFjaG1lbnRzGAYgAygLMiUuZG9tYWluLlNlbmRNZXNzYWdlUmVxdWVzdC5BdHRhY2htZW50Gj8KCkF0dGFjaG1lbnQSEAoIZmlsZW5hbWUYASABKAkSDAoEZGF0YRgCIAEoDBIRCgltaW1lX3R5cGUYAyABKAlKBAgDEAQiFQoTU2VuZE1lc3NhZ2VSZXNwb25zZSLmAQoRUmVwb3J0UGFnZVJlcXVlc3QSCwoDdXJsGAEgASgJEioKB3Byb2JsZW0YAiABKA4yGS5kb21haW4uUmVwb3J0UGFnZVByb2JsZW0SDwoHY29tbWVudBgDIAEoCRISCgpzY3JlZW5zaG90GAQgASgJEhEKCWhhc19sb2dpbhgFIAEoCBIeChZoYXNfaGlkZV9zZWNyZXRzX2xvZ2luGAYgASgIEhMKC3BhZ2Vfc291cmNlGAcgASgJEhcKD2hhc19zaGFkb3dfcm9vdBgIIAEoCBISCgpwcm9maWxlX2lkGAkgASgJIhQKElJlcG9ydFBhZ2VSZXNwb25zZSrfAgoSU3VwcG9ydE1lc3NhZ2VUeXBlEiAKHFNVUFBPUlRfTUVTU0FHRV9UWVBFX1VOS05PV04QABIlCiFTVVBQT1JUX01FU1NBR0VfVFlQRV9TVVBQT1JUX0ZPUk0QARImCiJTVVBQT1JUX01FU1NBR0VfVFlQRV9CRVRBX0ZFRURCQUNLEAISLQopU1VQUE9SVF9NRVNTQUdFX1RZUEVfQ0hBTkdFX0JJTExJTkdfRU1BSUwQAxIxCi1TVVBQT1JUX01FU1NBR0VfVFlQRV9VUERBVEVfTU9OSVRPUkVEX0RPTUFJTlMQBBIqCiZTVVBQT1JUX01FU1NBR0VfVFlQRV9OT05QUk9GSVRfUkVRVUVTVBAFEiEKHVNVUFBPUlRfTUVTU0FHRV9UWVBFX0FQUF9MT0dTEAYSJwojU1VQUE9SVF9NRVNTQUdFX1RZUEVfV0VCU0lURV9SRVBPUlQQByqdAgoRUmVwb3J0UGFnZVByb2JsZW0SHwobUkVQT1JUX1BBR0VfUFJPQkxFTV9VTktOT1dOEAASHQoZUkVQT1JUX1BBR0VfUFJPQkxFTV9PVEhFUhABEiEKHVJFUE9SVF9QQUdFX1BST0JMRU1fREVURUNUSU9OEAISIAocUkVQT1JUX1BBR0VfUFJPQkxFTV9QT1NJVElPThADEiIKHlJFUE9SVF9QQUdFX1BST0JMRU1fU1VCTUlTU0lPThAEEiAKHFJFUE9SVF9QQUdFX1BST0JMRU1fQVVUT0ZJTEwQBRIcChhSRVBPUlRfUEFHRV9QUk9CTEVNX0ZPUk0QBhIfChtSRVBPUlRfUEFHRV9QUk9CTEVNX1BBU1NLRVkQBzKhAQoOU3VwcG9ydFNlcnZpY2USSAoLU2VuZE1lc3NhZ2USGi5kb21haW4uU2VuZE1lc3NhZ2VSZXF1ZXN0GhsuZG9tYWluLlNlbmRNZXNzYWdlUmVzcG9uc2UiABJFCgpSZXBvcnRQYWdlEhkuZG9tYWluLlJlcG9ydFBhZ2VSZXF1ZXN0GhouZG9tYWluLlJlcG9ydFBhZ2VSZXNwb25zZSIAQjBaLmdpdGxhYi5jb20vY290ZWNoZGUvbW9ub3JlcG8vYmFja2VuZC9kb21haW4vcGJiBnByb3RvMw");

/**
 * @generated from message domain.SendMessageRequest
 */
export type SendMessageRequest = Message<"domain.SendMessageRequest"> & {
  /**
   * @generated from field: string subject = 1;
   */
  subject: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * optional
   *
   * @generated from field: string profile_id = 4;
   */
  profileId: string;

  /**
   * @generated from field: domain.SupportMessageType type = 5;
   */
  type: SupportMessageType;

  /**
   * optional
   *
   * @generated from field: repeated domain.SendMessageRequest.Attachment attachments = 6;
   */
  attachments: SendMessageRequest_Attachment[];
};

/**
 * Describes the message domain.SendMessageRequest.
 * Use `create(SendMessageRequestSchema)` to create a new message.
 */
export const SendMessageRequestSchema: GenMessage<SendMessageRequest> = /*@__PURE__*/
  messageDesc(file_support_service, 0);

/**
 * @generated from message domain.SendMessageRequest.Attachment
 */
export type SendMessageRequest_Attachment = Message<"domain.SendMessageRequest.Attachment"> & {
  /**
   * @generated from field: string filename = 1;
   */
  filename: string;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;

  /**
   * @generated from field: string mime_type = 3;
   */
  mimeType: string;
};

/**
 * Describes the message domain.SendMessageRequest.Attachment.
 * Use `create(SendMessageRequest_AttachmentSchema)` to create a new message.
 */
export const SendMessageRequest_AttachmentSchema: GenMessage<SendMessageRequest_Attachment> = /*@__PURE__*/
  messageDesc(file_support_service, 0, 0);

/**
 * @generated from message domain.SendMessageResponse
 */
export type SendMessageResponse = Message<"domain.SendMessageResponse"> & {
};

/**
 * Describes the message domain.SendMessageResponse.
 * Use `create(SendMessageResponseSchema)` to create a new message.
 */
export const SendMessageResponseSchema: GenMessage<SendMessageResponse> = /*@__PURE__*/
  messageDesc(file_support_service, 1);

/**
 * @generated from message domain.ReportPageRequest
 */
export type ReportPageRequest = Message<"domain.ReportPageRequest"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: domain.ReportPageProblem problem = 2;
   */
  problem: ReportPageProblem;

  /**
   * @generated from field: string comment = 3;
   */
  comment: string;

  /**
   * @generated from field: string screenshot = 4;
   */
  screenshot: string;

  /**
   * @generated from field: bool has_login = 5;
   */
  hasLogin: boolean;

  /**
   * @generated from field: bool has_hide_secrets_login = 6;
   */
  hasHideSecretsLogin: boolean;

  /**
   * @generated from field: string page_source = 7;
   */
  pageSource: string;

  /**
   * @generated from field: bool has_shadow_root = 8;
   */
  hasShadowRoot: boolean;

  /**
   * optional
   *
   * @generated from field: string profile_id = 9;
   */
  profileId: string;
};

/**
 * Describes the message domain.ReportPageRequest.
 * Use `create(ReportPageRequestSchema)` to create a new message.
 */
export const ReportPageRequestSchema: GenMessage<ReportPageRequest> = /*@__PURE__*/
  messageDesc(file_support_service, 2);

/**
 * @generated from message domain.ReportPageResponse
 */
export type ReportPageResponse = Message<"domain.ReportPageResponse"> & {
};

/**
 * Describes the message domain.ReportPageResponse.
 * Use `create(ReportPageResponseSchema)` to create a new message.
 */
export const ReportPageResponseSchema: GenMessage<ReportPageResponse> = /*@__PURE__*/
  messageDesc(file_support_service, 3);

/**
 * @generated from enum domain.SupportMessageType
 */
export enum SupportMessageType {
  /**
   * @generated from enum value: SUPPORT_MESSAGE_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: SUPPORT_MESSAGE_TYPE_SUPPORT_FORM = 1;
   */
  SUPPORT_FORM = 1,

  /**
   * @generated from enum value: SUPPORT_MESSAGE_TYPE_BETA_FEEDBACK = 2;
   */
  BETA_FEEDBACK = 2,

  /**
   * @generated from enum value: SUPPORT_MESSAGE_TYPE_CHANGE_BILLING_EMAIL = 3;
   */
  CHANGE_BILLING_EMAIL = 3,

  /**
   * @generated from enum value: SUPPORT_MESSAGE_TYPE_UPDATE_MONITORED_DOMAINS = 4;
   */
  UPDATE_MONITORED_DOMAINS = 4,

  /**
   * @generated from enum value: SUPPORT_MESSAGE_TYPE_NONPROFIT_REQUEST = 5;
   */
  NONPROFIT_REQUEST = 5,

  /**
   * @generated from enum value: SUPPORT_MESSAGE_TYPE_APP_LOGS = 6;
   */
  APP_LOGS = 6,

  /**
   * @generated from enum value: SUPPORT_MESSAGE_TYPE_WEBSITE_REPORT = 7;
   */
  WEBSITE_REPORT = 7,
}

/**
 * Describes the enum domain.SupportMessageType.
 */
export const SupportMessageTypeSchema: GenEnum<SupportMessageType> = /*@__PURE__*/
  enumDesc(file_support_service, 0);

/**
 * @generated from enum domain.ReportPageProblem
 */
export enum ReportPageProblem {
  /**
   * @generated from enum value: REPORT_PAGE_PROBLEM_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: REPORT_PAGE_PROBLEM_OTHER = 1;
   */
  OTHER = 1,

  /**
   * @generated from enum value: REPORT_PAGE_PROBLEM_DETECTION = 2;
   */
  DETECTION = 2,

  /**
   * @generated from enum value: REPORT_PAGE_PROBLEM_POSITION = 3;
   */
  POSITION = 3,

  /**
   * @generated from enum value: REPORT_PAGE_PROBLEM_SUBMISSION = 4;
   */
  SUBMISSION = 4,

  /**
   * @generated from enum value: REPORT_PAGE_PROBLEM_AUTOFILL = 5;
   */
  AUTOFILL = 5,

  /**
   * @generated from enum value: REPORT_PAGE_PROBLEM_FORM = 6;
   */
  FORM = 6,

  /**
   * @generated from enum value: REPORT_PAGE_PROBLEM_PASSKEY = 7;
   */
  PASSKEY = 7,
}

/**
 * Describes the enum domain.ReportPageProblem.
 */
export const ReportPageProblemSchema: GenEnum<ReportPageProblem> = /*@__PURE__*/
  enumDesc(file_support_service, 1);

/**
 * @generated from service domain.SupportService
 */
export const SupportService: GenService<{
  /**
   * errors:
   * - MissingCredentials (30100): missing credentials
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - OrganizationNotFound (60400): not member of the given organization
   * - ProfileNotFound (): not a profile of this user
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.SupportService.SendMessage
   */
  sendMessage: {
    methodKind: "unary";
    input: typeof SendMessageRequestSchema;
    output: typeof SendMessageResponseSchema;
  },
  /**
   * @generated from rpc domain.SupportService.ReportPage
   */
  reportPage: {
    methodKind: "unary";
    input: typeof ReportPageRequestSchema;
    output: typeof ReportPageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_support_service, 0);

